import React from "react";
import { Link } from "gatsby";

const ArticleByline = ({ authors }) => (
  <>
    {authors?.length > 0 && (
      <address>
        By {authors.map(({members_id}, index) => {
          return (
            <>
              {index > 0 && ", "}
              {members_id.author_slug ? (
                <Link to={`/${members_id.author_slug}`}>{members_id.first_name} {members_id.last_name}</Link>
              ) : (
                <span key={`author-${index}`}>
                  {members_id.first_name} {members_id.last_name}
                </span>
              )}
            </>
          )
        })}
      </address>
    )}
  </>
);
export default ArticleByline;